export function BrandLogo({ light = false, size = "md" }) {
  const h = size === "lg" ? "h-11" : size === "sm" ? "h-8" : "h-9";
  return (
    <div className="flex items-center" data-testid="brand-logo">
      <img
        src="/bocally-logo.png"
        alt="Bocally Holdings"
        className={`${h} w-auto ${light ? "brightness-0 invert" : ""}`}
      />
    </div>
  );
}
